import { UseAxiosResult } from "axios-hooks";
import formatUrl from "utils/formatUrl";

import portalApi from "config/urls/portalapi";

import { UseManagePortalApi } from "./setup";

export interface SignInMessage {
  message: string;
}

export const useSignInMessageQuery = () => {
  return UseManagePortalApi<SignInMessage>(
    {
      url: formatUrl(portalApi.signinMessages),
      method: "GET",
    },
    {
      manual: true,
    }
  );
};

export const useSignInMessageMutation = (): UseAxiosResult<SignInMessage> => {
  return UseManagePortalApi<SignInMessage>(
    {
      url: formatUrl(portalApi.signinMessages),
      method: "PUT",
    },
    {
      manual: true,
    }
  );
};
